var map = {
	"./1-01.svg": 819,
	"./1-02.svg": 471,
	"./1-03.svg": 470,
	"./1-04.svg": 820,
	"./1-05.svg": 2695,
	"./Community.svg": 589,
	"./Edit.svg": 425,
	"./Egg.svg": 2696,
	"./HighRise.svg": 588,
	"./Icons_25 nov-01 (1).svg": 1065,
	"./Icons_25 nov-02 (1).svg": 2697,
	"./Icons_25 nov-03 (1).svg": 2698,
	"./Icons_25 nov-04 (1).svg": 2699,
	"./Icons_25 nov-05 (1).svg": 2700,
	"./Icons_25 nov-05.svg": 2701,
	"./Icons_25 nov-06 (1).svg": 2702,
	"./Icons_25 nov-07 (2).svg": 1418,
	"./Icons_25 nov-07.svg": 2703,
	"./Icons_25 nov-08.svg": 1419,
	"./Icons_25 nov-09.svg": 1420,
	"./Icons_25 nov-10.svg": 1421,
	"./Icons_25 nov-12.svg": 1422,
	"./Icons_25 nov-13.svg": 2704,
	"./Icons_25 nov-14.svg": 1423,
	"./Icons_25 nov-15.svg": 2705,
	"./Notifications.svg": 1066,
	"./add.svg": 544,
	"./alert.svg": 2706,
	"./all.svg": 2707,
	"./call.svg": 1067,
	"./calories.svg": 713,
	"./car.svg": 472,
	"./chat.svg": 2708,
	"./check.svg": 821,
	"./chef-hat.svg": 1424,
	"./chef.svg": 1068,
	"./cloche.svg": 1425,
	"./cloche2.svg": 1426,
	"./clock (2).svg": 710,
	"./clock.svg": 712,
	"./credit-card (1)-1.svg": 2709,
	"./credit-card (1).svg": 162,
	"./curb side.svg": 341,
	"./delivery man icon.svg": 1069,
	"./delivery.svg": 308,
	"./dine in.svg": 342,
	"./dineOrder.svg": 854,
	"./failed.svg": 2710,
	"./gated.svg": 590,
	"./halal.svg": 1070,
	"./hourglass-1.svg": 1427,
	"./hourglass.svg": 719,
	"./house.svg": 587,
	"./less.svg": 543,
	"./list (1).svg": 822,
	"./list.svg": 2711,
	"./location.svg": 2712,
	"./location_red.svg": 432,
	"./mail.svg": 1428,
	"./menu-01.svg": 1429,
	"./non veg.svg": 549,
	"./online-payment.svg": 433,
	"./phone-credit card-money-finance.svg": 434,
	"./rikshaw.svg": 716,
	"./round-done-button.svg": 1430,
	"./rupees.svg": 545,
	"./scooter.svg": 715,
	"./serves.svg": 711,
	"./skip the line.svg": 343,
	"./skipTheLine.svg": 720,
	"./squares (1).svg": 823,
	"./star.svg": 542,
	"./success.svg": 718,
	"./takeaway.svg": 284,
	"./taxi.svg": 717,
	"./uncheck.svg": 605,
	"./veg.svg": 550,
	"./view.svg": 824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 548;